import type { BespokeTemplateResponse } from '../../services/api/types.gen';

export const FORM_SCHEMA_QUERY_PARAMS = {
  formType: 'formType',
  schemaName: 'schemaName',
  schemaVersion: 'schemaVersion',
  section: 'section',
  /** Bespoke template id when editing a non-active (standby) layout version. */
  layoutTemplate: 'layoutTemplate',
} as const;

/** Omit from URL when the edited row is the section's active Live/Paused template. */
export function layoutTemplateQueryValue(
  template: BespokeTemplateResponse | null | undefined,
  active: BespokeTemplateResponse | null | undefined
): string | null {
  if (!template) return null;
  if (active?.id === template.id) return null;
  return template.id;
}
